import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { labsApi } from './labs.api';
import { labKeys } from './labs.queries';
import type { LabsData } from './labs.api';

export function useUpdateLabsMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: LabsData) => labsApi.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: labKeys.all });
      toast.success('Labs updated successfully.');
    }
  });
}
